export interface PasswordRule {
  key: string;
  label: string;
  test: (password: string) => boolean;
}

export const PASSWORD_RULES: PasswordRule[] = [
  {
    key: 'minLength',
    label: 'Mínimo de 8 caracteres',
    test: (password) => password.length >= 8,
  },
  {
    key: 'uppercase',
    label: 'Uma letra maiúscula',
    test: (password) => /[A-Z]/.test(password),
  },
  {
    key: 'lowercase',
    label: 'Uma letra minúscula',
    test: (password) => /[a-z]/.test(password),
  },
  {
    key: 'number',
    label: 'Um número',
    test: (password) => /\d/.test(password),
  },
  {
    key: 'special',
    label: 'Um caractere especial',
    test: (password) => /[^A-Za-z0-9]/.test(password),
  },
];

export const isStrongPassword = (password: string): boolean =>
  PASSWORD_RULES.every((rule) => rule.test(password));

export const passwordsMatch = (
  password: string,
  confirmPassword: string
): boolean => password !== '' && password === confirmPassword;
